export const BOARD_BASIS_VALUES = ["BB", "HB", "FB"];
const BOARD_BASIS_LEVEL = { BB: 1, HB: 2, FB: 3 };

export const BOARD_BASIS_OPTIONS = [
  { value: "", label: "None" },
  ...BOARD_BASIS_VALUES.map((value) => ({ value, label: value })),
];

export function normalizeBoardBasis(value) {
  const normalized = String(value || "").trim().toUpperCase();
  return BOARD_BASIS_VALUES.includes(normalized) ? normalized : "";
}

export function getGuestBoardBasis(source) {
  return normalizeBoardBasis(
    source?.boardBasis
    || source?.boardbasis
    || source?.heliteBoardBasis
    || source?.helite_board_basis
  );
}

export function isIncludedByBoardBasis(product, guestBoardBasis) {
  const productBoardBasis = normalizeBoardBasis(product?.boardBasis);
  const activeBoardBasis = normalizeBoardBasis(guestBoardBasis);
  return Boolean(
    productBoardBasis
    && activeBoardBasis
    && BOARD_BASIS_LEVEL[productBoardBasis] <= BOARD_BASIS_LEVEL[activeBoardBasis]
  );
}

export function formatBoardBasis(value, fallback = "-") {
  return normalizeBoardBasis(value) || fallback;
}
